<template>
  <section class="if-container-wrapper">
    <div class="row">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-xs-12 mb-3 mt-0 text-center">

            <!-- Options Section -->
            <div class="row">
              <div class="header-wrapper mx-3">
                <div class="header-title-wrapper mt-1">
                  <div class="d-flex align-center">
                    feedback over
                    <div class="d-flex flex-row justify-start align-center">
                      <div class="form-group mb-0">
                        <div class="input-group">
                          <div id="filterId" />
                            <select
                              class="feedback-over form-control input"
                              @input="event => {
                                        filterHandler('day', event.target.value);
                                      }">
                              <option
                                v-for="(option, index) in days"
                                :selected="option.value == dataConfig.params.days"
                                :value="option.value"
                                :key="index">
                                {{ option.name }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-center">
                      <section>
                        <div class="d-flex justify-start align-center">
                          <div class="d-flex flex-row justify-start align-center mr-5">
                            <div class="form-group mb-0">
                              <div class="input-group">
                                <div id="tagged-items-filter-id" />
                                <select
                                  class="tagged-item form-control input"
                                  @input="event => {
                                            filterHandler('tag', event.target.value);
                                          }">
                                  <option
                                    v-for="(option, index) in tags"
                                    :value="option.value"
                                    :key="index">
                                    {{ option.name }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                    </div>


                    <div class="d-flex align-center">
                    sort by
                      <div class="sortType-wrapper">
                        <section>
                          <div class="d-flex justify-start align-center">
                            <div class="d-flex flex-row justify-start align-left mr-5">
                              <div class="form-group mb-0">
                                <div class="input-group sortType-group">

                                  <select
                                    class="form-control input"
                                    @input="event => {
                                              filterHandler('sortType', event.target.value);
                                            }">
                                    <option
                                      v-for="(option, index) in sortTypes"
                                      :value="option.value"
                                      :key="index">
                                      {{ option.name }}
                                    </option>
                                  </select>
                                  <a
                                    id="sort-order"
                                    v-if="dataConfig.params.sort == 'DESC'"
                                    @click="filterHandler('sort', 'ASC')"
                                    class="desc btn-down">
                                    <fai :icon="['fas', 'chevron-down']" class="ml-1"/>
                                  </a>
                                  <a
                                    id="sort-order"
                                    v-if="dataConfig.params.sort == 'ASC'"
                                    @click="filterHandler('sort', 'DESC')"
                                    class="asc btn-up">
                                    <fai :icon="['fas', 'chevron-up']" class="ml-1"/>
                                  </a>
                                </div>

                              </div>
                            </div>
                          </div>
                        </section>

                      </div>
                    </div>

                    <div class="d-flex align-center ">
                      <div class="reaction-email-wrapper">
                        <a
                          @click="showReactionModal()"
                        >want to be notified for low scores?</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Line Row -->
              <div class="row">
                <div class="col-sm-12"><hr style="margin:10px 10px" /></div>
              </div>
            </div>

            <!-- Body -->
            <div>
              <section class="important-feedback-body mb-2">
                <div class="d-flex justify-center" v-if="showLoading">
                  <sb-loading-icon />
                </div>
                <div v-else-if="importantFeedback.length != 0 && importantFeedback.data.length != 0" >
                  <transition-group appear name="list" tag="div" class="timeline mb-0">
                    <div
                      v-for="item in importantFeedback.data"
                      :key="item.id"
                      class="feedback-item-wrapper mb-5">

                      <ImportantFeedbackItem :item="item" />
                    </div>
                  </transition-group>
                </div>
                <div v-else class="text-center"><h4>no results</h4></div>
              </section>
            </div>

            <!-- Pagination -->
            <div v-if="importantFeedback.length != 0 && !showLoading">
              <div class="col-xs-12">
                <div class="d-flex justify-end align-center">
                  <div class="d-flex justify-center align-center mr-1">
                    <button
                      class="btn prev-btn btn-primary btn-small"
                      :disabled="importantFeedback.current_page == 1"
                      :class="{'disabled': importantFeedback.current_page == 1}"
                      @click="handleGetPage('prev')">
                      <fai :icon="['fas', 'chevron-left']" class="mr-1"/>prev
                    </button>
                  </div>
                  <div class="d-flex justify-center align-center mx-3">
                    showing {{ paginationText }} of {{importantFeedback.total}} results
                  </div>
                  <div class="d-flex justify-center align-center ml-1">
                    <button
                      class="btn next-btn btn-primary btn-small"
                      :disabled="importantFeedback.current_page == importantFeedback.last_page"
                      :class="{'disabled': importantFeedback.current_page == importantFeedback.last_page}"
                      @click="handleGetPage('next')">
                      next<fai :icon="['fas', 'chevron-right']" class="ml-1"/>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReactionEmailModal
        v-if="showModal"
        @click="showModal=true"
        @close="showModal=false"
      />
  </section>
</template>

<script>
import { feedbackAPI } from "../../../../services/api/feedbackAPI"
import ImportantFeedbackItem from '../ImportantFeedbackItem';
import ReactionEmailModal from '../ReactionEmailModal';
import { MessageBox } from "uiv";

export default {
  name: "ImportantFeedbackContainer",
  components: {
    MessageBox,
    ImportantFeedbackItem,
    ReactionEmailModal
  },
  data() {
    return {
      days: [
        {
          value: "3",
          name: "last 3 days"
        },
        {
          value: "7",
          name: "last 7 days"
        },
        {
          value: "14",
          name: "last 14 days"
        },
        {
          value: "30",
          name: "last 30 days"
        }
      ],
      tags: [
        {
          value: "all",
          name: "all tags"
        },
        {
          value: "open",
          name: "open tags"
        },
        {
          value: "resolved",
          name: "resolved tags"
        },
        {
          value: "flagged",
          name: "flagged"
        }
      ],
      sortTypes: [
        {
          value: "created_at",
          name: "feedback date"
        },
        {
          value: "nps",
          name: "nps"
        },
        {
          value: "crs",
          name: "cs"
        },
        {
          value: "product",
          name: "product"
        }
      ],
      importantFeedback: [],
      dataConfig: {
        params: {
          days: 7,
          tagType: 'all',
          sort: 'DESC',
          page: 1,
          sortType: 'created_at'
        }
      },
      showLoading: true,
      showModal: false
    };
  },
  async created() {
    this.importantFeedback = await feedbackAPI.GETImportantFeedback(this.dataConfig)
    this.$root.$on("setStore", () => {
      this.refresh()
    });
    this.showLoading = false
  },
  computed: {
    paginationText() {
      const from = this.importantFeedback.from
      const to = this.importantFeedback.to

      if(from && to) return `${from}-${to}`
      return 0
    }
  },
  methods: {
    refresh: async function() {
      this.showLoading = true
      this.importantFeedback = await feedbackAPI.GETImportantFeedback(this.dataConfig)
      this.showLoading = false
    },
    filterHandler: async function(filter, val) {
      this.showLoading = true
      switch(filter) {
        case 'day':
          this.dataConfig.params.days = val;
          break;
        case 'tag':
          this.dataConfig.params.tagType = val;
          break;
        case 'sort':
          this.dataConfig.params.sort = val;
          break;
        case 'sortType':
          this.dataConfig.params.sortType = val;
          break;
      }

      this.dataConfig.params.page = 1
      this.importantFeedback = await feedbackAPI.GETImportantFeedback(this.dataConfig);
      this.showLoading = false
    },
    handleGetPage: async function (direction) {
      this.showLoading = true
      const { importantFeedback } = this;

      if (direction == 'prev') {
        if (importantFeedback.current_page == 1) return;

        this.dataConfig.params.page = importantFeedback.current_page - 1;
      } else if (direction == 'next') {
        if (importantFeedback.current_page == importantFeedback.last_page) return;

        this.dataConfig.params.page = importantFeedback.current_page + 1;
      }

      window.scrollTo(0,0)

      this.importantFeedback = await feedbackAPI.GETImportantFeedback(this.dataConfig);
      this.showLoading = false
    },
    showReactionModal(){
      this.showModal = true;
    }
  }
};
</script>
